module.exports = __webpack_public_path__ + "img/dsci0003.92e7ecbd.jpg";